module.exports = __webpack_public_path__ + "img/Authorization.aa5a1e56.png";